export const MANGO_SCRIPT_SRC = `https://widgets.mango-office.ru/widgets/mango-callback.js`
export const BITRIX24_SCRIPT_SRC = `https://24.nbcom.ru/upload/crm/site_button/loader_3_5hk8wt.js`
export const TELEGRAM_CHAT_LINK = `tg://resolve?domain=iport_bot`
export const APPLE_CHAT_LINK = `https://bcrw.apple.com/sms:open?service=iMessage&recipient=urn:biz:efa77289-13bf-4a49-af93-d8cee3dd020f`
